import React, { useState } from "react";
import { Heading } from "../../../design/heading";
import { Field, Fieldset, Label } from "../../../design/fieldset";
import { Input } from "../../../design/input";
import { useMatter } from "../../../contexts/MatterContext";
import { Matter } from "../../../models/Matter";
import { Button } from "../../../design/button";

const MatterOverview: React.FC = () => {
  const { updateMatter, currentMatter } = useMatter();
  const [matter, setMatter] = useState<Matter | undefined>(currentMatter);
  const [isSaving, setIsSaving] = useState(false);

  const handleChange = (field: keyof Matter, value: string) => {
    setMatter((prev) => (prev ? { ...prev, [field]: value } : undefined));
  };

  const handleSubmit = async () => {
    if (!matter) return;

    setIsSaving(true);
    try {
      await updateMatter(currentMatter?._id!, matter);
    } catch (error) {
      console.error("Error updating court details:", error);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div>
      <div className="flex items-end justify-between gap-4">
        <Heading>Overview</Heading>
        <Button
          onClick={handleSubmit}
          disabled={
            isSaving || JSON.stringify(matter) === JSON.stringify(currentMatter)
          }
        >
          {isSaving ? "Saving..." : "Save"}
        </Button>
      </div>
      <Fieldset>
        <Field>
          <Label>Name</Label>
          <Input
            type="text"
            value={matter?.name || ""}
            onChange={(e) => handleChange("name", e.target.value)}
            placeholder="Enter matter name"
          />
        </Field>
      </Fieldset>
    </div>
  );
};

export default MatterOverview;
